import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import Span from "../../helper/Span";
import style from "../../sass/navigation.module.scss";

const NavList = () => {
     const location = useLocation();
     return (
          <>
               <NavLink to="/" className={style[location.pathname === "/" ? "navigation-items__link_active" : ""]}>
                    <li className={style["navigation-items__link"]}>
                         <div>
                              {"{Home}".split("").map((alphabet, index) => (
                                   <Span alp={alphabet} key={index} />
                              ))}
                         </div>
                         <div className={style.dot}></div>
                    </li>
               </NavLink>

               <NavLink to="/skill" className={style[location.pathname === "/skill" ? "navigation-items__link_active" : ""]}>
                    <li className={style["navigation-items__link"]}>
                         <div>
                              {"{Skill}".split("").map((alphabet, index) => (
                                   <Span alp={alphabet} key={index} />
                              ))}
                         </div>
                         <div className={style.dot}></div>
                    </li>
               </NavLink>

               <NavLink to="/project" className={style[location.pathname === "/project" ? "navigation-items__link_active" : ""]}>
                    <li className={style["navigation-items__link"]}>
                         <div>
                              {"{Project}".split("").map((alphabet, index) => (
                                   <Span alp={alphabet} key={index} />
                              ))}
                         </div>
                         <div className={style.dot}></div>
                    </li>
               </NavLink>

               <NavLink to="/certificate" className={style[location.pathname === "/certificate" ? "navigation-items__link_active" : ""]}>
                    <li className={style["navigation-items__link"]}>
                         <div>
                              {"{Certificate}".split("").map((alphabet, index) => (
                                   <Span alp={alphabet} key={index} />
                              ))}
                         </div>
                         <div className={style.dot}></div>
                    </li>
               </NavLink>

               <NavLink to="/contact" className={style[location.pathname === "/contact" ? "navigation-items__link_active" : ""]}>
                    <li className={style["navigation-items__link"]}>
                         <div>
                              {"{Contact}".split("").map((alphabet, index) => (
                                   <Span alp={alphabet} key={index} />
                              ))}
                         </div>
                         <div className={style.dot}></div>
                    </li>
               </NavLink>
          </>
     );
};
export default NavList;
